export default {
	GET: {
		articleList: '/api/pc/temp/article-list', //文章资讯
		articleDetail: '/api/default/article-detail', //资讯详情
		// headerindex: '/api/pc/temp/header', // 头部
		common: '/api/pc/temp/head-and-tail', // 公共头尾
		stencilindex:'/api/pc/temp/pc-stencil',	//模板首页
		index: '/api/pc/temp/index', // 首页
		footer: '/api/pc/temp/footer', //底部
		shopList: '/api/default/goods-list', // 商品列表
		shopgoods: '/api/default/goods', // 商品详情
		shopgoodsleft: '/api/default/goods-recommend', // 商品详情左侧推荐
		shopcat: '/api/cart/list', //购物车
		delectshop: '/api/cart/delete', // 删除购物车商品
		cartnum: '/api/cart/cart-num', //购物车数量
		rechargeList: '/api/recharge/list', //余额充值
		rechargeIndex: '/api/recharge/index', //余额明细
		addressList: '/api/user/address-list', //地址列表
		addressDelete: '/api/user/address-delete', //删除地址
		district: '/api/pc/temp/district', // 地址省市区
		addressDefault: '/api/user/address-set-default', //设为默认地址
		invoiceList: '/api/user/get-invoice-list', //发票抬头列表
		orderList: '/api/order/list', //订单列表
		orderRevoke: '/api/order/revoke', //取消订单
		orderPay: '/api/order/pay-data', //订单支付
		orderDetail: '/api/order/detail', //订单详情
		invoiceLists: '/api/pc/user/invoice-list', //发票列表
		invoiceDetails: '/api/pc/user/invoice', //发票详情
		confirm: '/api/order/confirm', //确认收货
		comment_preview: '/api/order/comment-preview', //确认收货
		expressDetail: '/api/order/express-detail', //物流
		refundPreview: '/api/order/refund-preview', //申请售后
		refundDetail: '/api/order/refund-detail', //退换货预览
		revokeRefund: '/api/order/revoke-refund', //撤回申请
		commentList: '/api/default/comment-list', //商品评价预览
		couponList: '/api/default/coupon-list', //优惠券
		ccouponReceive: '/api/coupon/receive', //优惠券领取
		shopFollow: '/api/mch/index/shop-follow', //商户关注
		shopUnFollow:  '/api/mch/index/un-follow', //商户取消关注
		mchList: '/api/pc/temp/mch-list', //店铺街
		province: '/api/pc/temp/province', //店铺街-省份地区
		shopIndex: '/api/mch/default/index', //店铺首页
		catGoodsList: '/api/mch/default/cat-goods-list', //店铺商品列表
		myShop: '/api/mch/user/myshop', //店铺信息
		introduce: '/api/mch/default/introduce', //店铺资质
		mchMessage: '/api/mch/default/mch-message', //入驻店铺-模板信息
		apply: '/api/mch/index/apply', //个人中心-入驻店铺-审核、交付平台使用费
		mchMoney: '/api/mch/user/mch-money', //入驻店铺-保证金
		payMoney: '/api/mch/user/pay-money', //入驻店铺-支付保证金
		allCategories: '/api/pc/temp/all-categories', //入驻店铺-全部分类
		store: '/api/default/store',//商城配置
		customerService: '/api/pc/temp/customer-service',//店铺客服链接
		tjDetails: '/api/tjzc/goods/details', //天津商品
		integral:'/api/integralmall/integralmall/pc-index' , //积分商城首页
		integralDetail:'/api/integralmall/integralmall/goods-info', //积分商城详情页
		integralPrew:'/api/integralmall/integralmall/submit-preview', //积分商城订单预览
		integarlPay:'/api/integralmall/integralmall/submit',//积分订单支付
		integarlOrderList: '/api/integralmall/integralmall/list', //积分订单列表
		integarlRevoke: '/api/integralmall/integralmall/revoke', //积分取消订单
		integarlConfirm: '/api/integralmall/integralmall/confirm', //积分确认收货
		integarlOrderSubmit: '/api/integralmall/integralmall/order-submit', //积分订单支付
		integarlOrderDetails: '/api/integralmall/integralmall/clerk-order-details', //积分订单详情
		integarlDetail: '/api/integralmall/integralmall/integral-detail', //积分明细
		personalintegar:'/api/integralmall/integralmall/my-integral',	//我的积分
		getCustomerList: '/api/default/get-customer-list',//获取客服列表
		refund_preview:'/api/alibaba/order/refund-preview',	//1688-退款退货预览订单
		personalcoupon:"/api/coupon/index",//我的优惠券
		collstore:"/api/user/mch-follow-list",//收藏的店铺
		collshop:"/api/user/favorite-list",		//收藏的商品
		user_notice:"/api/mch/default/entry-rules",//入驻商协议  用户须知
		baofuOrderStatus: '/api/order/order-is-pay', //宝付订单状态
		baofuRechargeOrderStatus: '/api/recharge/order-is-pay', //余额充值-宝付订单状态
		baofuIntegralOrderStatus: '/api/integralmall/integralmall/order-is-pay', //积分兑换-宝付订单状态
	},
	POST: {
		whether: '/api/passport/user-occupation', //手机号是否存在
		resSale: '/api/default/res-sale', //获取短信验证token
		sendCode: '/api/default/send-code', //获取手机验证码
		register: '/api/passport/register', //注册
		pcLogin: '/api/passport/pc-login', //验证码登录
		changePassword: '/api/passport/change-password', //忘记密码
		userIndex: '/api/pc/user/pc', //个人中心
		// userIndex: '/api/pc/user/index', //个人中心
		rechargeSubmit: '/api/recharge/submit', //充值提交
		shopcar: '/api/cart/add-cart', // 加入购物车
		orderStatus: '/api/pc/order-status', //订单状态
		addressSave: '/api/user/address-save', //地址编辑
		uploadImage: '/api/default/upload-image', //图片上传
		submitPreview: '/api/order/new-submit-preview', //预览订单
		newSubmit: '/api/order/new-submit', //提交订单
		modifycart: '/api/cart/cart-edit', //购物车修改
		pushInvoice: '/api/user/push-invoice', //添加发票
		userSave: '/api/user/user-save', //修改用户信息
		comment: '/api/order/comment', //修改用户信息
		refund: '/api/order/refund', //申请售后提交
		refundSend: '/api/order/refund-send', //申请售后提交
		suitAddcart: '/api/cart/suit-add-cart', //套餐加入购物车
		favoriteAdd: '/api/user/favorite-add', // 商品收藏
		favoriteRemove: '/api/user/favorite-remove', // 商品取消收藏
		applySubmit: '/api/mch/index/apply-submit',//入驻店铺-提交
		wxLogin: '/api/passport/wx-login',//微信登录
		wxLoginCheck: '/api/passport/check',//微信登录校验
		appLogin: '/api/passport/app-login',//微信登录绑定手机号
		integralSubmit:'/api/integralmall/integralmall/submit',//积分商城提交订单
		zzDetails: '/api/zzds/goods/get-goods-info-two', //中直商品
		alirefund:'/api/alibaba/order/refund',	//1688-售后提交接口
		refund_send: "/api/alibaba/order/refund-send",//1688-退款退货提交
		sticky_Topic:"/api/mch/index/oper-top",//置顶收藏店铺
		statistics_data:'/api/statistics/statistics/index', // 埋点
		investmentSubmit: '/api/mch/investment',//招商-提交
	}
}
